"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardDetails = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _utils = require("../../utils.js");
var _excluded = ["lineClamp", "children", "variant", "semanticColor", "as", "href", "weight", "hasTextSeparator"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LineClamp = _styledComponents["default"].span.withConfig({
  displayName: "CardDetails__LineClamp",
  componentId: "sc-1gdonml-0"
})(["", ""], function (_ref) {
  var $lineClamp = _ref.$lineClamp;
  return (0, _styledComponents.css)(["display:", ";-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], '-webkit-box', $lineClamp);
});
var CardDetailText = (0, _styledComponents["default"])(_index2.Text).withConfig({
  displayName: "CardDetails__CardDetailText",
  componentId: "sc-1gdonml-1"
})(["", ""], (0, _index.overflowWrapFlexText)());

/**
 * CardDetails is used as a slot default for Card pretitle, body and footer and can be used to create custom components.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-card-carddetails--docs) |
 * [Encore site](https://encore.spotify.net/web/components/cards) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/CardDetails) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-19606&t=98l5kv0xhhpGkxaj-1)
 */
var CardDetails = exports.CardDetails = /*#__PURE__*/_react["default"].forwardRef(function CardDetails(_ref2, ref) {
  var lineClamp = _ref2.lineClamp,
    children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'bodySmall' : _ref2$variant,
    _ref2$semanticColor = _ref2.semanticColor,
    semanticColor = _ref2$semanticColor === void 0 ? 'textSubdued' : _ref2$semanticColor,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'p' : _ref2$as,
    href = _ref2.href,
    weight = _ref2.weight,
    _ref2$hasTextSeparato = _ref2.hasTextSeparator,
    hasTextSeparator = _ref2$hasTextSeparato === void 0 ? false : _ref2$hasTextSeparato,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var subtitleNode = children;
  if (hasTextSeparator && Array.isArray(children)) {
    subtitleNode = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children.map(function (child, index) {
      if (children.length - 1 === index) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: index
        }, child);
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: index
      }, child, " \u2022 ");
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(CardDetailText, Object.assign({
    forwardedAs: href ? 'a' : as,
    href: href,
    variant: (0, _utils.mapLegacyToTextVariant)(variant, weight),
    semanticColor: semanticColor,
    ref: ref,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.CardDetails
  }, props), lineClamp ? /*#__PURE__*/_react["default"].createElement(LineClamp, {
    $lineClamp: lineClamp
  }, subtitleNode) : subtitleNode);
});